export default "__VITE_ASSET__609cc40f__"